import { useEffect, useState } from 'react';
import { SKLADS_WAREHOUSE, TYPE_BUTTONS } from '../../../../constans';

import ReservesApi from '../../../../API/warehouse/reserves-api';
import { Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { DateInput, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import styles from './styles.module.scss';

const CreateReserve = ({ close = () => { } }) => {
  const [data, setData] = useState({
    timeScheduled: null,
    market: '',
    skladName: SKLADS_WAREHOUSE[0]
  });

  const validate = () => {
    return data.timeScheduled;
  };

  const clickAdd = () => {
    if (validate()) {
      ReservesApi.createReserve({ data: { ...data, skladName: data.skladName.short_name } }).then((r) => {
        close();
      });
    }
  };

  useEffect(() => {
    // getStaff(dispatch);
  }, []);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
        <H2 style={{ marginBottom: '20px' }}>Добавить новый резерв</H2>
        <Row>
          <Select
            label="Площадка"
            width="250px"
            list={['Ozon+Yandex', 'Wildberries', 'Ozon', 'Yandex']}
            onSelect={(v) => setData({ ...data, market: v })}
            style={{ marginRight: '15px' }}

          />
          <Select
            label="Город"
            select={data.skladName}
            list={SKLADS_WAREHOUSE}
            valueFn={(p) => p.name}
            onSelect={(v) => setData({ ...data, skladName: v })}
            width="200px"
          />
        </Row>

        <Row style={{ marginTop: '20px' }}>
          <InputLabel style={{ marginRight: '20px' }}>Дата сборки резерва</InputLabel>
          <DateInput onChange={(v) => setData({ ...data, timeScheduled: v })} />
        </Row>

        <Row style={{ marginTop: '30px' }}>
          <Button
            type={TYPE_BUTTONS.BLUE}
            disabled={!data.timeScheduled}
            style={{
              marginRight: '15px',
            }}
            onClick={!data.timeScheduled ? () => { } : clickAdd}
          >
            Добавить
          </Button>
          <Button type={TYPE_BUTTONS.GREY} onClick={close}>
            Отменить
          </Button>
        </Row>
    </PopUp>
  );
};

export default CreateReserve;
